const isEmptyValue = (val) => {
  if (!val) return true;
  if (Array.isArray(val)) {
    return val.every((item) => isEmptyValue(item));
  }
  if (typeof val === "string") {
    const trimmed = val.trim();
    return !trimmed || trimmed === "-";
  }
  return false;
};

const LABEL_MAP = {
  allergies: "Drug allergies",
  breastFeeding: "Breast feeding",
  conditions: "Medical conditions",
  medications: "Medications and supplements",
};

const getLabel = (name) => {
  if (LABEL_MAP[name]) return LABEL_MAP[name];
  return name.charAt(0).toUpperCase() + name.slice(1);
};

/**
 * Validates a single field in the Medical Details form.
 * @param {string} name - Field name
 * @param {any} value - Field value
 * @param {string} [sex] - Sex / Gender
 * @returns {string|null} - Error message or null if valid
 */
export const validateMedicalField = (name, value, sex) => {
  const isRequiredGeneral = ["smoker", "allergies", "sex"].includes(name);
  const isRequiredFemale =
    ["pregnant", "breastFeeding"].includes(name) && sex === "Female";

  const resolvedValue = Array.isArray(value) ? value.join(", ") : value;

  if (isRequiredGeneral || isRequiredFemale) {
    if (isEmptyValue(resolvedValue)) {
      return `${getLabel(name)} is required`;
    }
  }

  if (name === "conditions" || name === "medications") {
    if (isEmptyValue(resolvedValue)) {
      return `${getLabel(name)} is required`;
    }
  }

  return null;
};

/**
 * Validates the entire Medical Details form data.
 * @param {object} data - Medical details data
 * @returns {object} - Object containing errors for each field
 */
export const validateMedicalDetailsForm = (data) => {
  const errors = {};
  const fields = [
    "smoker",
    "allergies",
    "conditions",
    "medications",
    "sex",
    "pregnant",
    "breastFeeding",
  ];

  fields.forEach((field) => {
    const error = validateMedicalField(field, data[field], data.sex);
    if (error) errors[field] = error;
  });

  return errors;
};
